module.exports = __webpack_public_path__ + "img/電気回路_1_4_3.c8d04460.png";